/**
 *
 * @param func callback to be excuted after provided delay
 * @param delay number in "ms" to add delay in func excution
 * @returns closure is returned. This closure clears any existing timer and sets a new timer using setTimeout.
 */
function nextgenDebounce(func: Function, delay: number): Function {
  let timerId: ReturnType<typeof setTimeout>;

  return function (...args: any[]) {
    // clearing existing timer, if any.
    clearTimeout(timerId);
    // setting new timer
    timerId = setTimeout(() => {
      func(...args);
    }, delay);
  };
}

export { nextgenDebounce };
